import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const OrdersSection = lazy(() => import('components/Sections/Orders'))
const Footer = lazy(() => import('components/Layout/Footer'))

function Orders() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <OrdersSection />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default Orders